const SESSION_KEY = 'wisecalc.usuario';
const SESSION_ID_KEY = 'wisecalc.sessionId';
const DEVICE_ID_KEY = 'wisecalc.deviceId';
let tipoUsuarioEmMemoria = null;

function usuarioValido(usuario) {
  return usuario &&
    typeof usuario === 'object' &&
    typeof usuario.email === 'string' &&
    usuario.email.trim() &&
    typeof usuario.nome === 'string';
}

function normalizarUsuario(usuario) {
  if (!usuarioValido(usuario)) return null;

  return {
    nome: usuario.nome.trim(),
    email: usuario.email.trim().toLowerCase()
  };
}

export function getUsuario() {
  try {
    localStorage.removeItem(SESSION_KEY);
    localStorage.removeItem('usuario');
    const valor = sessionStorage.getItem(SESSION_KEY);
    if (!valor) return null;

    const usuario = normalizarUsuario(JSON.parse(valor));
    if (!usuario) return null;
    return usuario;
  } catch (error) {
    sessionStorage.removeItem(SESSION_KEY);
    return null;
  }
}

export function setUsuario(usuario) {
  const usuarioAtual = getUsuario() || {};
  tipoUsuarioEmMemoria = usuario?.tipo || tipoUsuarioEmMemoria;
  const usuarioFinal = normalizarUsuario({
    nome: usuario?.nome ?? usuarioAtual.nome ?? '',
    email: usuario?.email ?? usuarioAtual.email ?? '',
    tipo: usuario?.tipo ?? usuarioAtual.tipo ?? 'usuario'
  });

  if (!usuarioFinal) {
    throw new Error('Dados de sessão inválidos.');
  }

  sessionStorage.setItem(SESSION_KEY, JSON.stringify(usuarioFinal));
}

export function getTipoUsuario() {
  return tipoUsuarioEmMemoria;
}

export async function carregarTipoUsuario() {
  const usuario = await carregarUsuarioAtual();
  return usuario ? tipoUsuarioEmMemoria : null;
}

export async function carregarUsuarioAtual() {
  const sessionId = getSessionId();
  if (!sessionId) return null;

  try {
    const resposta = await fetch(`${process.env.VUE_APP_BACKEND_URL}/sessao-atual`, {
      headers: {
        'x-session-id': sessionId
      }
    });

    if (!resposta.ok) {
      sessionStorage.removeItem(SESSION_KEY);
      if (resposta.status === 401) clearUsuario();
      return null;
    }

    const dados = await resposta.json();
    tipoUsuarioEmMemoria = dados.tipo || null;
    setUsuario(dados);
    return getUsuario();
  } catch (error) {
    sessionStorage.removeItem(SESSION_KEY);
    console.error('Não foi possível carregar a sessão do usuário:', error);
    return null;
  }
}

export function clearUsuario() {
  tipoUsuarioEmMemoria = null;
  sessionStorage.removeItem(SESSION_KEY);
  sessionStorage.removeItem(SESSION_ID_KEY);
  localStorage.removeItem(SESSION_KEY);
  localStorage.removeItem(SESSION_ID_KEY);
  localStorage.removeItem('usuario');
}

export function setSessionId(sessionId) {
  if (typeof sessionId !== 'string' || !sessionId) {
    throw new Error('Identificador de sessão inválido.');
  }

  localStorage.setItem(SESSION_ID_KEY, sessionId);
}

export function getSessionId() {
  return localStorage.getItem(SESSION_ID_KEY) || sessionStorage.getItem(SESSION_ID_KEY);
}

export function getDeviceId() {
  let deviceId = localStorage.getItem(DEVICE_ID_KEY);

  if (!deviceId) {
    deviceId = crypto.randomUUID();
    localStorage.setItem(DEVICE_ID_KEY, deviceId);
  }

  return deviceId;
}
